import { Colors } from '@mercator-gcp/grout';
import { capitalize } from 'lodash';
import { Text } from 'components/elements/Text';
import Tooltip from 'components/elements/Tooltip';
import { FlexRow } from 'components/layout/FlexRow';

const verticalListContainer = {
  gap: '4px',
};

const verticalLabelStyle = {
  color: Colors.ArmyGreen900,
  fontSize: '12px',
};

export const ProjectListVerticalSection = ({ vertical }: { vertical: string }) => {
  const verticalArray = vertical ? vertical.split(',') : [];

  if (!verticalArray.length) {
    return null;
  }

  if (verticalArray.length > 1) {
    return (
      <FlexRow>
        <Tooltip
          tooltipText={verticalArray
            .slice(1)
            .map((item) => capitalize(item))
            .join(', ')}
        >
          <FlexRow sx={verticalListContainer}>
            <Text sx={verticalLabelStyle}>{capitalize(verticalArray[0])} </Text>
            <Text sx={verticalLabelStyle}>+{Number(verticalArray.length - 1)}</Text>
          </FlexRow>
        </Tooltip>
      </FlexRow>
    );
  }

  return (
    <FlexRow>
      <Text sx={verticalLabelStyle}>{capitalize(verticalArray[0])}</Text>
    </FlexRow>
  );
};
